export function trackEvent(event, data = {}, options = {}) {
  const payload = {
    event,
    ts: new Date().toISOString(),
    ...data,
  };

  try {
    const events = JSON.parse(localStorage.getItem('profitpulse_events') || '[]');
    events.push(payload);
    localStorage.setItem('profitpulse_events', JSON.stringify(events.slice(-100)));
  } catch {}

  const shop = options.shop || data.shop;
  if (!shop) return;

  try {
    fetch('/api/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop,
        event,
        metadata: data,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}
